<script setup lang="ts">
import zhCN from "ant-design-vue/es/locale/zh_CN";
import dayjs from "dayjs";
import { computed } from "vue";
import "dayjs/locale/zh-cn";
import { useUserStore } from "./stores";

/**
 * @description 语言枚举(我们当前语言枚举与antd-vue，dayjs等库的语言枚举不一致，需要转换)
 */
enum LANG_ENUM {
	zh = "zh-cn",
}

/**
 * @description antd-vue语言映射
 */
const antdLangMap = {
	zh: zhCN,
};

const currentLang = computed(
	() => (localStorage.getItem("lang") || "zh") as keyof typeof LANG_ENUM
);

dayjs.locale(LANG_ENUM[currentLang.value]);

const userStore = useUserStore();
const userInfo = computed(() => userStore.userInfo);

const ua = navigator.userAgent;
const match = ua.match(/Chrom(e|ium)\/(\d+)\./);

if (match && parseInt(match[2], 10) < 90) {
	alert(
		"当前浏览器谷歌版本内核过低，建议使用谷歌浏览器、Edge浏览器或者火狐浏览器等主流浏览器，以获得更好的体验！"
	);
}

const showWatermark = import.meta.env.VITE_APP_WATERMARK === "true";

/**
 * 更新水印
 */
const watermarkContent = computed(() => {
	const projectName = import.meta.env.VITE_PROJECT_NAME;
	const username = userInfo.value?.username;
	const nowDate = new Date().toLocaleString();

	return showWatermark ? `${projectName}${username ? `-${username}` : ""}-${nowDate}` : "";
});
</script>

<template>
	<a-config-provider
		:locale="antdLangMap[currentLang]"
		:theme="{
			token: {
				colorPrimary: '#165dff',
				colorSuccess: '#00b42a',
				colorError: '#f53f3f',
				colorWarning: '#ff8d28',
				controlHeightLG: 40,
				controlHeight: 36,
				controlHeightSM: 32,
				borderRadius: 4,
				borderRadiusLG: 6,
				borderRadiusSM: 2,
			},
		}"
	>
		<a-watermark class="full" :content="watermarkContent">
			<RouterView />
		</a-watermark>
	</a-config-provider>
</template>
